<template>
  <div class="drawer">
    <div class="accordion menu" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseOne">
            Yango
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
          <div class="accordion-body">
            <router-link @click.native="back" class="route-btn w-100 bg-transparent" :to="{ name : 'InvoiceStatus' }">
              <font-awesome-icon class="icon" icon="fa-receipt"/>
              Invoice Records
            </router-link>
            <router-link @click.native="back" class="route-btn w-100 bg-transparent" :to="{ name : 'Billing' }">
              <font-awesome-icon class="icon" icon="fa-money-bill"/>
              Billing
            </router-link>
            <router-link @click.native="back" class="route-btn w-100 bg-transparent" :to="{ name : 'NotSubmitted' }">
              <font-awesome-icon class="icon" icon="fa-triangle-exclamation"/>
              Not Submitted
            </router-link>
          </div>

        </div>
      </div>

      <div class="accordion-item">
        <div class="accordion-body">
          <router-link @click.native="back" class="route-btn w-100 bg-transparent" :to="{ name : 'Login' }">
            <font-awesome-icon class="icon" icon="fa-solid fa-lock"/>
            User Logout
          </router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Side navigation drawer with route links and optional close callback.
 */
export default defineComponent({
  name: 'NavigationDrawer',
  props: {
    close: {
      type: Function,
      default: null,
    },
  },
  /**
   * NavigationDrawer setup — closes the drawer after route selection.
   */
  setup(props) {
    /** Invokes the parent close callback when a route is chosen. */
    function back(): void {
      if (typeof props.close === 'function') {
        props.close();
      }
    }

    return { back };
  },
});
</script>

<style lang="scss" scoped>
a {
  &:hover, &.a-exact-active {
    background: var(--ct-surface-100);
    color: var(--ct-primary);
    .icon { color: var(--ct-primary); }
  }
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid var(--ct-surface-200);
}

.menu {
  text-align: center;
  span {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 600;
  }
}

.icon {
  margin-right: 12px;
  color: var(--ct-surface-500);
  font-size: 1.2rem;
  width: 20px;
  text-align: center;
}

.route-btn {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  font-size: 0.9rem;
  padding-left: 16px;
  text-decoration: none;
  color: var(--ct-surface-700);
  border-radius: 8px;
  margin: 2px 8px;
  transition: all 0.15s ease;
}

.accordion-button {
  font-weight: 600;
  color: var(--ct-surface-700);
  font-size: 0.95rem;
  &:not(.collapsed) { background: var(--ct-surface-50); color: var(--ct-primary); box-shadow: none; }
  &:focus { box-shadow: none; }
}

.accordion-item {
  border: none;
}
</style>